import React, {useContext} from 'react';
import "./ProgressSlider.scss"
import {I18nReactContext} from "../../../contexts/I18nContext";
import {signDocProgressTypes} from "../../../Components/SignDoc/SignDocLib";

export const SignDocProgressSlider = ({progressPercent, viewed, signed, type}) => {
    const {i18n} = useContext(I18nReactContext);
    let actualProgress = progressPercent;
    
    // For non-continuous types, map to discrete values
    if (!signDocProgressTypes.includes(type)) {
        actualProgress = viewed && !signed ? 50 : (signed ? 100 : 0);
    }

    // Helper function to determine if a milestone should be highlighted
    const isMilestoneActive = (milestone) => actualProgress >= milestone;

    // Helper function to get text state class
    const getTextStateClass = (milestone) => {
        if (milestone === 0) return actualProgress > 0 ? 'on' : '';
        if (milestone === 50) return actualProgress >= 50 ? 'on' : '';
        return actualProgress === 100 ? 'on' : '';
    };

    return <div className="ProgressSlider CourseProgressSlider">
        <div className="progressBar">
            <div className={`progressRound startRound ${isMilestoneActive(0) ? 'on' : ''}`}/>
            <div className={`progressRound middleRound ${isMilestoneActive(50) ? 'on' : ''}`}/>
            <div className={`progressRound endRound ${isMilestoneActive(100) ? 'on' : ''}`}/>
        </div>
        <div className="overlayProgressBar" style={{width: `${actualProgress}%`}}/>
        <div className="progressTexts">
            <div className={`progressText startText ${getTextStateClass(0)}`}>
                {i18n.translate(`signDocProgress.notStarted.${type}`)}
            </div>
            <div className={`progressText middleText ${getTextStateClass(50)}`}>
                {i18n.translate(`signDocProgress.inProgress.${type}`)}
            </div>
            <div className={`progressText endText ${getTextStateClass(100)}`}>
                {i18n.translate(`signDocProgress.finished.${type}`)}
            </div>
        </div>
    </div>
}

